import React from 'react';

import { OrganizationCard as OrganizationCardType } from '../../types';

import * as S from './styles';

type Props = {
  card: OrganizationCardType;
  onClick?: () => void;
};

function OrganizationCard({ card, onClick }: Props) {
  const { name, logoUrl } = card;

  return (
    <S.CardContainer onClick={onClick}>
      <S.LogoWrapper>
        <S.OrganizationLogo alt={`${name} logo`} src={logoUrl} />
      </S.LogoWrapper>
      <S.OrganizationName>{name}</S.OrganizationName>
    </S.CardContainer>
  );
}

export default OrganizationCard;
